// extracted by mini-css-extract-plugin
export default {"main-content":"Container_main-content__2ggi8","container":"Container_container__MhTjW"};